import Contacts from '@/src/components/screens/Contacts/Contacts';

export default function ContactsPage() {
    return <Contacts />;
}
